<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">Quel est le produit majoritaire de la réaction suivante?</p>

      <p class="pl-12 mb-6">
        <v-img style="max-width: 217px" :src="imageHeadName" />
      </p>

      <v-radio-group v-model="inputs.input1" class="mb-0" :disabled="!allowEditing">
        <v-radio class="my-2" value="a">
          <template #label>
            <v-img :src="imageAName" style="max-width: 96px" />
          </template>
        </v-radio>

        <v-radio class="my-6" value="b">
          <template #label>
            <v-img :src="imageBName" style="max-width: 96px" />
          </template>
        </v-radio>

        <v-radio class="my-2" value="c">
          <template #label>
            <v-img :src="imageCName" style="max-width: 96px" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex.vue';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default {
  name: 'chemUott1721B_Task32',
  components: {StembleLatex},
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
      },
    };
  },
  computed: {
    imageHeadName() {
      return prefixPublicAsset('/img/assignments/task32_main.png');
    },
    imageAName() {
      return prefixPublicAsset('/img/assignments/task32_optionA.png');
    },
    imageBName() {
      return prefixPublicAsset('/img/assignments/task32_optionB.png');
    },
    imageCName() {
      return prefixPublicAsset('/img/assignments/task32_optionC.png');
    },
  },
};
</script>
